import { render, staticRenderFns } from "./HeaderT.vue?vue&type=template&id=8ffae316&scoped=true"
import script from "./HeaderT.vue?vue&type=script&lang=js"
export * from "./HeaderT.vue?vue&type=script&lang=js"
import style0 from "./HeaderT.vue?vue&type=style&index=0&id=8ffae316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffae316",
  null
  
)

export default component.exports